/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { LoadingOutlined } from '@ant-design/icons';

import { Node } from '@/client';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Space } from '@/primitives/Space';

export type NodeTransitionIndicatorProps = {
  node: Node;
};

export function NodeTransitionIndicator({ node }: NodeTransitionIndicatorProps) {
  const { t } = useMimicTranslation('node');

  const showTransitionIndicator =
    node.requestedRevisionState?.status === 'pending' &&
    node.appliedRevisionState?.operationalState !== node.requestedRevisionState.operationalState;

  if (!showTransitionIndicator) {
    return null;
  }

  return (
    <div
      style={{
        marginTop: '20px',
        marginBottom: '-16px',
        padding: '13px 16px',
        backgroundColor: '#fafafa',
        border: '1px solid #e8e8e8',
        borderRadius: '6px',
      }}
    >
      <Space size="xs" dataTestId="node-transition-indicator">
        <LoadingOutlined />
        {t('operationalStateChanging', {
          currentState: node.appliedRevisionState?.operationalState,
          requestedState: node.requestedRevisionState?.operationalState,
        })}
      </Space>
    </div>
  );
}
